import { Application } from "pixi.js";
import { initJuice } from "./juice";
import { Game } from "./game";

async function boot() {
  // Make sure Fredoka is ready before pixi rasterizes any text.
  try {
    await Promise.all([
      document.fonts.load('700 64px "Fredoka"'),
      document.fonts.load('600 24px "Fredoka"'),
      document.fonts.load('500 18px "Fredoka"'),
    ]);
    await document.fonts.ready;
  } catch {
    /* fall back to system font */
  }

  const app = new Application();
  await app.init({
    // NB: no `resizeTo: window` — Game.resize() is the single sizing authority
    // (it reads visualViewport and calls renderer.resize), so there's no race
    // between pixi's window-resize handler and ours, and we honor the URL-bar-
    // aware visual viewport on mobile.
    background: 0x0b1620,
    antialias: true,
    resolution: Math.min(window.devicePixelRatio || 1, 2),
    autoDensity: true,
    preference: "webgl",
  });

  document.getElementById("app")!.appendChild(app.canvas);

  initJuice(app.ticker);
  const game = new Game(app);
  game.start();

  (globalThis as Record<string, unknown>).__game = game; // handy for debugging
  document.getElementById("boot")?.classList.add("hidden");

  // Offline play (public/sw.js). Skipped on localhost so dev/HMR never fights
  // a cache — the SW's cache-first would happily serve stale hot-reloaded code.
  if ("serviceWorker" in navigator && !["localhost", "127.0.0.1"].includes(location.hostname)) {
    void navigator.serviceWorker.register("/sw.js").catch(() => {
      /* offline support is progressive enhancement */
    });
  }
}

boot().catch((err) => {
  console.error(err);
  const el = document.getElementById("boot");
  if (el) el.textContent = "Failed to start — check the console.";
});
